import React from 'react';
import styled, { keyframes } from "styled-components";

// Keyframe for the spinning animation
const spin = keyframes`
  0% {
    transform: rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: rotateX(180deg) rotateY(180deg);
  }
  100% {
    transform: rotateX(360deg) rotateY(360deg);
  }
`;

// Styled-component for the Loader container
const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
`;

// Styled-component for the spinning 3D loader
const Loader = styled.div`
  width: ${(props) => props.size || "150px"};
  height: ${(props) => props.size || "150px"};
  border: 6px solid transparent;
  border-top: 6px solid ${(props) => props.color || "pink"};
  border-right: 6px solid ${(props) => props.color || "#ff87a5"};
  border-radius: 50%;
  animation: ${spin} ${(props) => props.speed || "2s"} linear infinite;
  perspective: 1000px;
  transform-style: preserve-3d;
  box-shadow: 0 4px 15px rgba(255, 136, 170, 0.5);
`;
const Loading = ({ color = "pink", size = "80px", speed = "2s" }) => {
  return (
    <LoaderContainer>
      <Loader color={color} size={size} speed={speed} />
    </LoaderContainer>
  );
};

export default Loading;
